import template from './template.html';

function TipNotificationDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    controller: 'tipNotificationCtrl',
    template,
    link: function (scope, element, attrs, ctrl, transcludeFn) {
      //http://angular-tips.com/blog/2014/03/transclusion-and-scopes/
      //transclude so the inner html's scope is the directive controllers, and not a new scope
      transcludeFn(scope, function (clone) {
        const contentElement = element[0].querySelector('[ng-transclude]');

        contentElement.innerHTML = '';

        for (let i = 0; i < clone.length; ++i) { //eslint-disable-line
          contentElement.appendChild(clone[i]);
        }
      });
    }
  };
}

TipNotificationDirective.$inject = [];

export default TipNotificationDirective;



// WEBPACK FOOTER //
// ./src/directives/tipNotification/index.js